import init from "./init";

export const downloadDraftReport = (reportId, watermark = null) =>
    init.request({ url: `company/report/draft`, method: 'POST', responseType: 'blob', data: { reportId, watermark } })
        .then(({ data }) => data)

export const previewReport = (reportId) =>
    init.request({ url: `advisor/report/preview`, method: 'POST', responseType: 'blob', data: { reportId } })
        .then(({ data }) => data)
